import React from "react";
import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogContentText,
    DialogActions,
    Button,
    Alert,
} from "@mui/material";

export default function DeleteReportDialog(props) {
    const { open, onClose, onConfirm, reportInfo, user } = props;

    // Check if user has MANAGEMENT permissions
    const hasManagementPermission =
        user &&
        user.groups &&
        user.groups.some((group) => group.name === "MANAGEMENT");

    return (
        <Dialog
            open={open}
            onClose={onClose}
            aria-labelledby="delete-report-dialog-title"
            aria-describedby="delete-report-dialog-description"
        >
            <DialogTitle id="delete-report-dialog-title">
                Delete RF Test Report?
            </DialogTitle>
            <DialogContent>
                <DialogContentText id="delete-report-dialog-description">
                    Are you sure you want to delete this RF Test Report?
                    {reportInfo && (
                        <>
                            <br />
                            <br />
                            <strong>Report: {reportInfo.report_number}</strong>
                            <br />
                            <strong>Type: {reportInfo.test_type}</strong>
                        </>
                    )}
                    <br />
                    <br />
                    This action cannot be undone.
                </DialogContentText>
                {!hasManagementPermission && (
                    <Alert severity="warning" sx={{ mt: 2 }}>
                        You do not have permission to delete reports. Only users
                        in the MANAGEMENT group can delete RF Test Reports.
                    </Alert>
                )}
            </DialogContent>
            <DialogActions>
                <Button onClick={onClose} color="primary">
                    Cancel
                </Button>
                <Button
                    onClick={onConfirm}
                    color="error"
                    variant="contained"
                    autoFocus
                    disabled={!hasManagementPermission}
                >
                    Delete Report
                </Button>
            </DialogActions>
        </Dialog>
    );
}
